export default __webpack_public_path__ + "static/swirlyearrings-d5bdea5c26f21f6c43496bcac6c882cb.png";